import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

const POLL_INTERVAL_MS = 30_000;

export interface ScanStatus {
  scanning: boolean;
  isLongScan: boolean;
  startedAt: string | null;
}

export function useScanStatus(domainId: string): ScanStatus {
  const query = useQuery({
    queryKey: ['scan-status', domainId],
    queryFn: () => api.domains.scanStatus(domainId),
    staleTime: POLL_INTERVAL_MS,
    refetchInterval: () =>
      document.visibilityState === 'visible' ? POLL_INTERVAL_MS : false,
  });

  const data = query.data;
  return {
    scanning: data?.scanning ?? false,
    isLongScan: data?.isLongScan ?? false,
    startedAt: data?.startedAt ?? null,
  };
}
